exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#print-area{max-width:850px}.modal{text-align:center;padding:0!important}.modal:before{content:\"\";height:100%;margin-right:-4px}.modal-dialog,.modal:before{display:inline-block;vertical-align:middle}.modal-dialog{text-align:left}@media screen and (max-width:650px){#credit-table-header,#price-section2{width:500px;padding-left:10px}#price-section2{padding-top:10px;font-size:15px}#price-section{width:280px}#company-info{width:100%}#header-img{width:60px;height:60px}#print-area{max-width:100%}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5ee1328e","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/deliveryInvoice/ViewCustomerDeliveryInvoice.vue
// module id = 682
// module chunks = 0